import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useSession } from '../auth/session';

/**
 * Korumalı/korumasız ayrımı (SEOAI-78). Yalnızca OTURUM VAR MI diye bakar —
 * izne göre yönlendirme SEOAI-47'nin işidir ve buraya eklenmemelidir.
 *
 * Nereden geldiğini saklar: giriş sonrası kullanıcı aradığı sayfaya döner,
 * her seferinde anasayfaya değil.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const tokens = useSession((s) => s.tokens);
  const location = useLocation();

  if (!tokens) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
